import { ITransformTemplate, ITransformTemplateProvider } from 'smarthub-common'
import { transforms } from 'config'

export class LocalTransformTemplatesProvider implements ITransformTemplateProvider {
  public async process(): Promise<ITransformTemplate[]> {
    return Promise.resolve(transforms)
  }
}
